import type { ThemeOptions } from "@mui/material/styles";

interface ThemePreset {
  swatchColor: string;
  palette: ThemeOptions["palette"];
}

export const THEME_PRESETS = {
  campnerd: {
    swatchColor: "#4E7944",
    palette: {
      mode: "light",
      alternativeDatesBg: "#E4EBE2",
      primary: {
        main: "#4E7944",
        light: "#BADAB3",
        dark: "#3A5733",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#EB8F47",
      },
      background: {
        default: "#F0F3EF",
        paper: "#FFFFFF",
      },
      text: {
        primary: "#262626",
        secondary: "#666666",
        accent: "#4E7944",
      },
      divider: "#E5E5E5",
      warning: {
        main: "#FFFBE1",
        dark: "#663c00",
        contrastText: "#755E02",
      },
      error: {
        main: "#B64F64",
        light: "#FCEBEE",
        dark: "#611a15",
        contrastText: "#FFFFFF",
      },
      success: {
        main: "#4E7944",
        light: "#BADAB3",
        dark: "#3A5733",
        contrastText: "#FFFFFF",
      },
      info: {
        main: "#262626",
        light: "#A0A099",
        dark: "#9E9E9E",
        contrastText: "#262626",
      },
    },
  },
  light: {
    swatchColor: "#FAFAFA",
    palette: {
      mode: "light",
      alternativeDatesBg: "#fafafa",
      text: {
        accent: "#262626",
      },
      primary: {
        main: "#424242",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#757575",
      },
      background: {
        default: "#F8F8F8",
        paper: "#FFFFFF",
      },
      divider: "#E5E5E5",
      warning: {
        main: "#FFFBE1",
        dark: "#663c00",
        contrastText: "#755E02",
      },
      error: {
        main: "#B64F64",
        light: "#FCEBEE",
        dark: "#611a15",
        contrastText: "#FFFFFF",
      },
      success: {
        main: "#4E7944",
        light: "#BADAB3",
        dark: "#3A5733",
        contrastText: "#FFFFFF",
      },
      info: {
        main: "#262626",
        light: "#A0A099",
        dark: "#9E9E9E",
        contrastText: "#262626",
      },
    },
  },
  dark: {
    swatchColor: "#212121",
    palette: {
      mode: "dark",
      alternativeDatesBg: "#2c2c2c",
      text: {
        accent: "rgba(255, 255, 255, 0.87)",
      },
      primary: {
        main: "#E0E0E0",
        contrastText: "#212121",
      },
      secondary: {
        main: "#B0B0B0",
      },
      background: {
        default: "#212121",
        paper: "#2C2C2C",
      },
    },
  },
} as const satisfies Record<string, ThemePreset>;

export type ThemeName = keyof typeof THEME_PRESETS;

export const THEME_LABELS: Record<ThemeName, string> = {
  campnerd: "CampNerd",
  light: "Light",
  dark: "Dark",
};
